export const LOADED = "books/loaded";
export const ADDBOOK = "books/addbook";
export const DELETEBOOK = "books/deletebook";
export const UPDATEBOOK = "books/updatebook";